import Dashboard from "./screens/Dashbord/IoT";
import buyCredit from "./screens/buyCredit/buyCredit";
import allTicket from "./screens/SupportTicket/all-ticket";
import pendingTicket from "./screens/SupportTicket/pending-ticket";
import Customer from "./screens/Customer/index";
import verifyCustomer from "./screens/Customer/verify-customer";
import deposit from "./screens/Deposit/deposit";
import withdraw_transaction from "./screens/Withdraw/withdraw";
import manage_merchant from "./screens/Merchant/manage-merchant";
import manage_bank_account from "./screens/Bank/bank-account";
import user from "./screens/User/user";
import role from "./screens/Role/role";
import statement from "./screens/Bank/statement";
import client_transfer from "./screens/Bank/client-transfer";
import user_activity from "./screens/Activity/user-activity";
import VerifyTrans from "./screens/Verifyslip-transactions/index";
import setting from "./screens/Setting/setting";
import approveTransaction from "./screens/Deposit/approve-transaction";
import createInvoice from "./screens/Invoices/createInvoice";
import ManageInvoices from "./screens/Invoices/manage-invoices";
import report from "./screens/Report/chart-report";
import profileAdmin from "./screens/Pages/ProfileV1";
import transfer from "./screens/Transfer/index";
import UpdateList from "./screens/UpdateList";

import Login from "./screens/Login";
import Page403 from "./screens/Auth/Page403";
import Page404 from "./screens/Auth/Page404";
import Lockscreen from "./screens/Auth/Lockscreen";
import PushbulletGuide from "./components/Guide/pushbullet-guide";



export const RoutesPage = [
    { path: "/dashboard", component: Dashboard },
    { path: "/buyCredit", component: buyCredit },
    { path: "/all-ticket", component: allTicket },
    { path: "/pending-ticket", component: pendingTicket },
    { path: "/bank-bank-customer", component: Customer },
    { path: "/verify-customer", component: verifyCustomer },
    { path: "/deposit-transaction", component: deposit },
    { path: "/withdraw-transaction", component: withdraw_transaction },
    { path: "/manage-merchant", component: manage_merchant },
    { path: "/bank-account", component: manage_bank_account },
    { path: "/user", component: user },
    { path: "/role", component: role },
    { path: "/statement", component: statement },
    { path: "/client-transfer", component: client_transfer },
    { path: "/user-activity", component: user_activity },
    { path: "/verifyslip-transactions", component: VerifyTrans },
    { path: "/setting", component: setting },
    { path: "/top-up-approval", component: approveTransaction },
    { path: "/invoices", component: createInvoice },
    { path: "/manage-invoices", component: ManageInvoices },
    { path: "/chart-report", component: report },
    { path: "/profile", component: profileAdmin },
    { path: "/transfer", component: transfer },
    { path: "/updateList", component: UpdateList },
    { path: "/pushbullet-guide", component: PushbulletGuide },
];

export const AuthRoutePage = [
    { path: "/", component: Login },
    { path: "/login", component: Login },
    { path: "/page403", component: Page403 },
    { path: "/page404", component: Page404 },
    { path: "/lockscreen", component: Lockscreen },
    // { path: "/KrungthaiBusinessGuide", component: KrungthaiBusinessGuide },
];

export const authRoutes = [
    "",
    "/",
    "login",
    "page403",
    "page404",
    "lockscreen",
];

export const publicPage = [
    "/profile",
    "/updateList",
    "/",
    "/login",
    "/transfer",
    "/page403",
    "/page404",
    "/dashboard",
    "/pushbullet-guide",
];